export default {
    setUserTransactionChartData(state, payload) {
        state.userTransaction = payload;
    },
    setSentimentAnalysisChartData(state, payload) {
        state.sentimentAnalysis = payload;
    },
    setMainCategories(state, payload) {
        state.mainCategories = payload;
    },
    setSubCategories(state, payload) {
        state.subCategories = payload;
    },
    setDetailCategories(state, payload) {
        state.detailCategories = payload;
    },
    setOperationTransactionData(state, payload) {
        state.operationTransactions = payload;
    },
    setUserModerationActionsData(state, payload) {
        if (payload && payload.length > 0) {
            const hiddenContents = payload.find(x => x.series.find(y => y.name == "Gizleme Raporu"));
            const deletedContents = payload.find(x => x.series.find(y => y.name == "Silinen Raporu"));
            const blockedContents = payload.find(x => x.series.find(y => y.name == "Engellenen Kullanıcı Raporu"));

            state.userModerationHiddenContents = hiddenContents;
            state.userModerationBlockedContents = blockedContents;
            state.userModerationDeletedContents = deletedContents;
        }
    },
    setSelectedServiceLevelTimePeriods(state, payload) {
        state.selectedServiceLevelTimePeriods = payload;
    },
    setOperationServiceLevelData(state, payload) {
        const customTimePeriods = [];

        for (const timeItem of state.selectedServiceLevelTimePeriods) {
            const start = timeItem.start-1 < 0 ? timeItem.start : timeItem.start-1;
            const timeItemString = `${start}-${timeItem.end}`;

            customTimePeriods.push(timeItemString);
        }

        const formattedDatas = [];

        for (const responseItem of payload) {
            const dataItem = {};

            if (!formattedDatas.some(x => x.name == responseItem.name)) {
                dataItem.name = responseItem.name;

                formattedDatas.push(dataItem)
            }
        }

        let propCounter = 1;

        for (const timeItem of customTimePeriods) {
            for (const data of formattedDatas) {
                const filteredData = payload.find(x => x.sl == timeItem && x.name == data.name);
                let feedCount = 0;

                if (filteredData) {
                    feedCount = filteredData.feedCount;
                }

                if (propCounter < 10) {
                    data[`SL0${propCounter}`] = feedCount;
                } else {
                    data[`SL${propCounter}`] = feedCount;
                }
                    
            }

            propCounter++;
        }

        const lastItem = [...customTimePeriods].pop();
        const endTime = lastItem.split("-")[1];

        for (const data of formattedDatas) {
            const filteredData = payload.find(x => x.sl == `> ${endTime}` && x.name == data.name);
            let feedCount = 0;

            if (filteredData) {
                feedCount = filteredData.feedCount;
            }

            if (propCounter < 10) {
                data[`SL0${propCounter}`] = feedCount;
            } else {
                data[`SL${propCounter}`] = feedCount;
            }
        }

        propCounter++;

        for (const data of formattedDatas) {
            const filteredDatas = payload.filter(x => x.name == data.name);

            let total = 0;

            for (const filteredData of filteredDatas) {
                total += filteredData.feedCount;
            }

            data.total = total;
        }

        const currentPropCounter = propCounter;

        for (const data of formattedDatas) {
            let iterationPropCounter = currentPropCounter;

            for (let index = 0; index < customTimePeriods.length+1; index++) {
                let feedCount = 0;

                if (index == 0) {
                    feedCount = data.SL01;
                } else if (index == 1) {
                    feedCount = data.SL02;
                } else if (index == 2) {
                    feedCount = data.SL03;
                } else if (index == 3) {
                    feedCount = data.SL04;
                } else if (index == 4) {
                    feedCount = data.SL05;
                } else if (index == 5) {
                    feedCount = data.SL06;
                } else if (index == 6) {
                    feedCount = data.SL07;
                } else if (index == 7) {
                    feedCount = data.SL08;
                }

                if (feedCount != 0) {
                    if (iterationPropCounter < 10) {
                        data[`SL0${iterationPropCounter}`] = Math.floor((feedCount * 100) / data.total);
                    } else {
                        data[`SL${iterationPropCounter}`] = Math.floor((feedCount * 100) / data.total);
                    }
                } else {
                    if (iterationPropCounter < 10) {
                        data[`SL0${iterationPropCounter}`] = 0;
                    } else {
                        data[`SL0${iterationPropCounter}`] = 0;
                    }
                }

                iterationPropCounter++;
            }
        }

        state.operationServiceLevels = formattedDatas;
    },
    setUserTagData(state, payload) {
        state.userTags = payload;
    },
    setMisalignedResponseData(state, payload) {
        state.misalignedResponses = payload;
    },
    setOperationFeedFinalizeData(state, payload) {
        state.feedFinalizeDetails = payload.operationFeedFinalizeRawDataList;

        for (const summaryData of payload.operationFeedFinalizeSummaryList) {
            if (!summaryData.avgAnswerTime) {
                summaryData.avgAnswerTime = 0;
            }

            if (!summaryData.totalAnsweredFeedCount) {
                summaryData.totalAnsweredFeedCount = 0;
            }
        }

        state.feedFinalizeSummaries = payload.operationFeedFinalizeSummaryList;
    },
    setTopFeederData(state, payload) {
        state.topFeeder = payload;
    },
    setIdleUserData(state, payload) {
        state.idleUsers = payload;
    }
}